// Auto-generated by scripts/prefetch-marketing-pages.mjs — DO NOT EDIT
// Generated at: 2026-08-27T07:46:26.947Z
import { Routes } from '@angular/router';

export const MARKETING_PRO_PAGE_SLUGS = ["apps/music-band-fan-club"] as const;

export const MARKETING_PRO_PAGE_ROUTES: Routes = [
  {
    path: 'apps',
    children: [
    {
      path: 'music-band-fan-club',
      loadChildren: () =>
      import('../modules/marketing-pro-page/marketing-pro-page.module').then(
        (m) => m.MarketingProPageModule
      ),
      data: { marketingProSlug: 'apps/music-band-fan-club' }
    }
    ]
  }
];
